import InsightFiltersViewModel from "../../ViewModels/InsightFiltersViewModel"
import React, { useContext, useState, useEffect } from "react"
import { APIContext } from "../../../Contexts/APIContext"
import AutoCompleteFilterContainer from "../GenericFilters/Select/AutoCompleteFilterContainer"


interface IAgentFilterContainerProps {
    filters: InsightFiltersViewModel
    setFilters: React.Dispatch<React.SetStateAction<InsightFiltersViewModel>>
}

export default function AgentFilterContainer({ filters, setFilters }: IAgentFilterContainerProps) {
    const { get } = useContext(APIContext);
    const [agentNames, setAgentNames] = useState<string[]>([]);

    useEffect(() => {
        get('Insight', `GetAgentNames?client=${filters.client}`, (data) => setAgentNames(data))
    }, [filters.client])

    return (
        <>
            <AutoCompleteFilterContainer
                filters={filters}
                setFilters={setFilters}
                name={'agentName'}
                label={'Agent Name'}
                options={agentNames} />
        </>
    );
}